"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ToggleSwitchComponent.default;
  }
});

var _ToggleSwitchComponent = _interopRequireDefault(require("./ToggleSwitch-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }